import React from 'react'
import { Switch, Route, BrowserRouter } from 'react-router-dom'
import { ContainerPages } from '../pages/ContainerPages'
import { useAuthentication } from '../context/authenticationContext'

const AppRouter = () => {
  const { isAuthenticated } = useAuthentication()

  return (
    <BrowserRouter>
      <Switch>
        <Route
          isAuthenticated={isAuthenticated}
          path="/"
          component={ContainerPages}
        />
      </Switch>
    </BrowserRouter>
  )
}

export default AppRouter
